import React from 'react';
import { createRoot } from 'react-dom/client';
import styled from 'styled-components';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';
import Constants from '../../submodules/logictry_config/constants';
import { Card, Form, LogoHeader, PrimaryButton, Title, twModalSurfaceShadow } from '../../styledhtml/Tailwind';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding-top: var(--logictry-popup-safe-top, 0px);
  padding-bottom: var(--logictry-popup-safe-bottom, 0px);
  background: rgba(32, 33, 36, 0.6);
`;

const DialogCard = styled(Card)`
  box-shadow: ${twModalSurfaceShadow};
  max-width: calc(100vw - 3rem);
`;

class UpdateRequiredPopup extends LogictryComponent {
  componentDidMount() {
    this.props.checker.onStateUpdate(this);
  }

  componentWillUnmount() {
    this.props.checker.offStateUpdate(this);
  }

  openStore = () => {
    const url = Constants.isAndroid ? Constants.GoogleStore : Constants.AppleStore;
    window.open(url);
  };

  render() {
    const { checker } = this.props;
    if (!checker.updateRequired) return null;
    const native = Constants.isIphone;
    return (
      <Overlay>
        <DialogCard onClick={(e) => e.stopPropagation()}>
          <LogoHeader>
            <img src={Constants.Logo} alt="Logictry" />
          </LogoHeader>
          <Title>{native ? 'You need to update the mobile app' : 'Update Required'}</Title>
          {native && (
            <Form>
              <PrimaryButton type="button" onClick={this.openStore}>
                {Constants.isAndroid ? 'Open Google Play' : 'Open App Store'}
              </PrimaryButton>
            </Form>
          )}
        </DialogCard>
      </Overlay>
    );
  }
}

let mounted = false;

export function mountUpdateRequiredPopup(checker) {
  if (mounted || typeof document === 'undefined') return;
  const attach = () => {
    if (mounted) return;
    mounted = true;
    const el = document.createElement('div');
    el.id = 'logictry-update-required';
    document.body.appendChild(el);
    createRoot(el).render(<UpdateRequiredPopup checker={checker} />);
  };
  if (document.body) attach();
  else document.addEventListener('DOMContentLoaded', attach);
}
